<template>
  <main>
    <md-steppers md-active-step="start" md-alternative md-linear>
      <md-step id="email" md-label="メール認証"></md-step>
      <md-step id="apply" md-label="本契約の手続き"></md-step>
      <md-step id="start" md-label="ご利用開始"></md-step>
    </md-steppers>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-90 md-small-size-100">
        <h2 class="md-title">本契約が完了しました。</h2>
        <p>
          この度はシカクマップをご契約いただき、誠にありがとうございます。<br>
          ご登録いただいたメールアドレスへ当サービスのIDとパスワードを送信いたしました。<br>
          ご確認いただきますよう、お願い申し上げます。
        </p>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <md-card-actions class="md-layout">
          <div class="md-layout-item md-size-20 md-layout md-alignment-center-left">
          </div>
          <div class="md-layout-item md-size-60 md-layout md-alignment-center-center">
            <md-button class="md-raised md-primary" @click="login()">
              <span>シカクマップ ログイン画面へ</span>
              <md-icon>arrow_right</md-icon>
            </md-button>
          </div>
          <div class="md-layout-item md-size-20 md-layout md-alignment-center-right">
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </main>
</template>

<script>
import Common       from "../../modules/common";
import {mapActions} from "vuex";

export default {
  name: "ContractComplete",
  mounted() {
    localStorage.removeItem(Common.localStorageKeys.contract.email)
    this.saveFormData(null);
  },
  methods: {
    ...mapActions('contractForm', [
      'saveFormData',
    ]),
    login() {
      this.$router.replace({name: 'MapLogin'});
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-card {
  margin-top: 20px;
  margin-bottom: 30px;
}

.mb-40 {
  margin-bottom: 40px;
}

.md-card-actions {
  .md-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
